// assets/quote-form-validation.js
(function () {
  const forms = Array.from(document.querySelectorAll('form[id^="quote-form-"]'));
  if (!forms.length) return;
  forms.forEach(attachValidation);

  function attachValidation(form) {
    // ---- Constraints ----
    const constraints = {
      'contact[name]': {
        presence: { allowEmpty: false, message: '^Name is required' }
      },
      'contact[email]': {
        presence: { allowEmpty: false, message: '^Email is required' },
        email: { message: '^Please enter a valid email address' }
      },
      'contact[phone]': {
        presence: { allowEmpty: false, message: '^Phone number is required' },
        format: {
          pattern: /^[0-9+()\-.\s]{7,}$/,
          message: '^Please enter a valid phone number'
        }
      },
      'contact[message]': {
        presence: { allowEmpty: false, message: '^Message is required' }
      },
      'contact[postcode]': {
        format: {
          pattern: /^(?:GIR 0AA|[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2})$/i,
          message: '^Please enter a valid UK postcode',
          allowEmpty: true
        }
      }
    };

    const fields = Object.keys(constraints)
      .map(name => ({ name, el: form.querySelector(`[name="${cssEscape(name)}"]`) }))
      .filter(f => !!f.el);

    if (!fields.length) return;

    // ---- Error summary ----
    let summary = form.querySelector('[data-error-summary]');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'alert mt-6 bg-error-bg text-error-text';
      summary.setAttribute('role', 'alert');
      summary.setAttribute('data-error-summary', 'true');
      summary.hidden = true;
      summary.innerHTML = `
        <h2 class="h5 text-current">There was an error submitting the form:</h2>
        <ul class="styled-list" data-error-list></ul>
      `;
      form.appendChild(summary);
    }
    const summaryList = summary.querySelector('[data-error-list]');

    // ---- Helpers ----
    function ensureInlineErrorEl(fieldEl) {
      const id = `${fieldEl.id || fieldEl.name}-error`;
      let p = form.querySelector(`#${cssEscape(id)}`);
      if (!p) {
        p = document.createElement('p');
        p.className = 'form__field-error';
        p.id = id;
        p.hidden = true;
        fieldEl.insertAdjacentElement('afterend', p);
      }
      return p;
    }

    function setFieldError(fieldEl, message) {
      const p = ensureInlineErrorEl(fieldEl);
      if (message) {
        fieldEl.setAttribute('aria-invalid', 'true');
        fieldEl.setAttribute('aria-describedby', p.id);
        p.textContent = message;
        p.hidden = false;
        fieldEl.classList.remove('is-valid');
        fieldEl.classList.add('is-invalid');
      } else {
        fieldEl.removeAttribute('aria-invalid');
        fieldEl.removeAttribute('aria-describedby');
        p.textContent = '';
        p.hidden = true;
        // Only mark valid if it has a value
        if (fieldEl.value.trim()) {
          fieldEl.classList.remove('is-invalid');
          fieldEl.classList.add('is-valid');
        } else {
          fieldEl.classList.remove('is-valid', 'is-invalid');
        }
      }
    }

    function clearSummary() {
      summary.hidden = true;
      summaryList.innerHTML = '';
    }

    function renderSummary(errorsByName) {
      clearSummary();
      const names = Object.keys(errorsByName || {});
      if (!names.length) return;
      names.forEach(name => {
        const messages = errorsByName[name];
        if (!messages || !messages.length) return;
        const li = document.createElement('li');
        li.textContent = messages[0];
        summaryList.appendChild(li);
      });
      summary.hidden = false;
    }

    function validateForm() {
      const values = collectValues(fields);
      const prunedConstraints = pruneConstraints(constraints, fields);
      return validate(values, prunedConstraints, { fullMessages: false }) || undefined;
    }

    function validateSingle(fieldEl) {
      const name = fieldEl.name;
      const valueObj = { [name]: fieldEl.value };
      const constraintObj = { [name]: constraints[name] };
      if (!constraintObj[name]) return undefined;
      const result = validate(valueObj, constraintObj, { fullMessages: false });
      return result && result[name];
    }

    function collectValues(fieldList) {
      const obj = {};
      fieldList.forEach(({ name, el }) => {
        obj[name] = el.value;
      });
      return obj;
    }

    function pruneConstraints(all, fieldList) {
      const obj = {};
      fieldList.forEach(({ name }) => (obj[name] = all[name]));
      return obj;
    }

    // ---- Live validation ----
    fields.forEach(({ el }) => {
      el.addEventListener('blur', () => {
        const errs = validateSingle(el);
        setFieldError(el, errs ? errs[0] : '');
      });

      el.addEventListener('input', () => {
        clearSummary();
        debounce(el, () => {
          const errs = validateSingle(el);
          setFieldError(el, errs ? errs[0] : '');
        });
      });

      el.addEventListener('change', () => {
        const errs = validateSingle(el);
        setFieldError(el, errs ? errs[0] : '');
      });
    });

    // ---- Submit validation ----
    form.addEventListener('submit', function (e) {
      const errors = validateForm();
      fields.forEach(({ el }) => setFieldError(el, ''));
      if (errors) {
        e.preventDefault();
        Object.keys(errors).forEach(name => {
          const field = form.querySelector(`[name="${cssEscape(name)}"]`);
          if (field) setFieldError(field, errors[name][0]);
        });
        renderSummary(errors);
        const firstInvalid = form.querySelector('[aria-invalid="true"]');
        if (firstInvalid) firstInvalid.focus({ preventScroll: false });
      }
    });
  }

  // ---- Utilities ----
  const debouncers = new WeakMap();
  function debounce(el, fn, delay = 200) {
    const prev = debouncers.get(el);
    if (prev) clearTimeout(prev);
    const t = setTimeout(fn, delay);
    debouncers.set(el, t);
  }

  function cssEscape(str) {
    return String(str).replace(/(["\\])/g, '\\$1');
  }
})();
